import { inject, Injectable, signal } from "@angular/core";
import { FuncService } from "../../../services";
import { WebLink } from "@interfaces";

@Injectable({ providedIn: 'root' })
export class WebLinkService{

	private func = inject(FuncService);
	private readonly isLoaded = signal<boolean>(false);
	public readonly webLinks = signal<WebLink[]>([]);


	public async getWebLinks(personId: number) {
		if (!this.isLoaded()) {
			const results = await this.func.webLink.getWebLinks({ personId });
			this.webLinks.set(results);
			this.isLoaded.set(true);
		}
	}

	public async addWebLink(personId: number, url: string, webLinkTypeId: number) {
		const webLinks = await this.func.webLink.addWebLink({ personId, url, webLinkTypeId });
		this.webLinks.set(webLinks);
	}

	public async updateWebLink(personId: number, webLinkToUpdate: WebLink) {
		const webLinks = await this.func.webLink.updateWebLink({ personId, webLinkToUpdate });
		this.webLinks.set(webLinks);
	}

}